import { createContext } from '@lit/context';
import { Messages } from "../../@types/online-reservation.js";

export const i18nContext = createContext<Messages>('i18nContext');
